import fly from 'flyio'
import handler from '@/utils/handleErrors'
import NProgress from 'nprogress'
import router from '@/router'
import handleErrors from '../utils/handleErrors'

fly.config = {
  ...fly.config,
  timeout: 100000,
  withCredentials: true,
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Content-Security-Policy': 'default-src http: https:'
  }
}

fly.interceptors.request.use(config => {
  if (config.url != '/sendVerificationCode') {
    NProgress.start()
  }
  // console.log(config);
  // NProgress.start()
  // console.log(config)
  if (config.type === 'cas') {
    console.log('-===', process.env.VUE_APP_BASE_CAS)
    config.baseURL = '/cas'
    delete config.type
  }
  if (config.json) {
    config.headers['Content-Type'] = 'application/json; charset=UTF-8'
    delete config.json
  }

  return config
})

fly.interceptors.response.use(({ data }) => {
  NProgress.done()

  if (data.status !== 200) {
    handler._notify(data)
  }

  if (data.status === 401) {
    handler[401]()
    // handleErrors._redirectLogin(to.fullPath)
  }

  return data
}, error => {
  const code = error.status

  if (handler[code]) {
    handler[code](error)
  } else {
    handler._notify(error)
  }

  return error
})

export default fly
